import { Injectable } from '@angular/core';
import {
  ProjectsFacade,
  customDecode,
  customEncode,
  customEncrypt,
  decrypt,
} from '@piqet-angular/data';
import {
  AccessPermissionService,
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { ColDef } from 'ag-grid-community';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { NumericCellEditor } from 'libs/ui/src/lib/numeri-cell-editor/numeric-cell-editor.component';
import { cloneDeep } from 'lodash';
import { Subject, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProductLossDataGridService {
  inlineEditingProductSaveData = new Subject<any>();
  inlineEditingProductSaveData$ = this.inlineEditingProductSaveData.asObservable();

  inlineEditingProductDeleteData = new Subject<any>();
  inlineEditingProductDeleteData$ = this.inlineEditingProductDeleteData.asObservable();

  clearInputFieldProduct = new Subject<any>();
  clearInputFieldProduct$ = this.clearInputFieldProduct.asObservable();

  editProductSub = new Subject<any>();
  editProductSub$ = this.editProductSub.asObservable();

  constructor(
    private swalService: SwalService,
    private projectsFacade: ProjectsFacade,
    private accessService: AccessPermissionService,
    private sharedService: SharedService
  ) {}

  accessPermission(): boolean {
    return this.accessService.hasPermission('edit', '', 'packaging');
  }

  productMixtureCols(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'Product',
      field: 'name',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.style.cursor =
          !isNaN(params.data.productId) && params.data.productId > 0 ? 'pointer' : 'auto';
        cellElement.style.textDecoration =
          !isNaN(params.data.productId) && params.data.productId > 0 ? 'underline' : 'none';
        cellElement.innerHTML = `${cellValue}`;
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          if (params.data.productId) {
            localStorage.setItem('productConfigId', params.data.parentId);
            const encodedValue = encodeURIComponent(params.data.parentId);
            const encryptedValue = customEncrypt(params.data.productId);
            this.sharedService.scenarioNameFunc(params.data?.name ?? '');

            window.open(
              `/#/projects/product-configuration/${customEncode(
                btoa(encodedValue)
              )}/configurations?param=${encryptedValue}`,
              '_blank'
            );
          }
        });
        return cellElement;
      },
    });
    colDef.push({
      ...defaultColumn,
      colId: 'Description',
      headerName: 'Description',
      field: 'description',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });
    colDef.push({
      ...defaultColumn,
      colId: 'Ratio',
      headerName: 'Ratio (%)',
      field: 'ratio',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
      maxWidth: grid_widths_map.sm_column_sm,
    });

    this.accessPermission() &&
      colDef.push({
        ...defaultColumn,
        colId: 'actions',
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        maxWidth: grid_widths_map.sm_column_xs,
        suppressColumnsToolPanel: true,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'inlineActionButtonComponent',
        cellRendererParams: {
          showInlineEdit: true,
          showInlineDelete: true,
          from: 'projectPages',
          deleteInlineGrid: (data: any) => {
            this.deleteConfirmation(data);
          },
          editDataInline: (data: any, pathName: any) => {
            this.projectsFacade.updateProductMixAction(data, 'editInline');
            this.editProductSub.next([data, true]);
          },
          saveDataInline: (data: any) => {
            this.inlineEditingProductSaveData.next(data);
          },
          clearInputField: (data: any) => {
            this.clearInputFieldProduct.next(data);
          },
        },
        autoHeight: true,
        lockVisible: true,
        lockPosition: true,
        resizable: false,
      });
    return colDef;
  }

  deleteConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.inlineEditingProductDeleteData.next(data);
      }
    });
  }
}
